
export const common = {
  nav: {
    quemSomos: 'Qui Sommes-Nous',
    servicos: 'Services',
    portfolio: 'Portfolio',
    processo: 'Processus',
    pedirOrcamento: 'Demander un Devis'
  },
  hero: {
    titulo: 'Qui n\'apparaît pas,',
    titulo2: 'ne vend pas.',
    subtitulo: 'Agence spécialisée en stratégie, réseaux sociaux, branding et production audiovisuelle professionnelle.',
    botaoOrcamento: 'Demander un Devis',
    botaoWhatsapp: 'WhatsApp'
  },
  quemSomos: {
    titulo: 'Nous transformons les marques en références.',
    texto1: '<strong>Olhar Criativo</strong> est une agence stratégique axée sur des résultats réels. Nous ne faisons pas que de jolis posts — nous construisons le positionnement, l\'autorité et la croissance durable pour les marques qui veulent dominer leur marché.',
    texto2: 'Nous combinons stratégie de marketing digital, production audiovisuelle haut de gamme et design sophistiqué pour créer des expériences qui convertissent les abonnés en clients fidèles.'
  },
  servicos: {
    titulo: 'Services qui génèrent des résultats',
    subtitulo: 'Solutions complètes de marketing et de production créative pour les marques qui veulent croître avec stratégie et professionnalisme.',
    gestaoRedes: 'Gestion des Réseaux Sociaux',
    gestaoRedesDesc: 'Stratégie complète pour Instagram, Facebook et TikTok. Nous créons du contenu qui génère un engagement réel, augmente les abonnés qualifiés et transforme votre présence digitale en machine à ventes.',
    producaoConteudo: 'Production de Contenu',
    producaoConteudoDesc: 'Photographie et vidéo professionnelles qui élèvent la perception de votre marque. Nous produisons du contenu visuel à fort impact qui distingue votre entreprise de la concurrence et attire le client idéal.',
    designGrafico: 'Design Graphique',
    designGraficoDesc: 'Design stratégique qui communique l\'essence de votre marque. Nous créons l\'identité visuelle, les matériaux graphiques et les posts qui transmettent professionnalisme et autorité dans chaque détail.',
    branding: 'Branding',
    brandingDesc: 'Nous construisons des marques mémorables à partir de zéro ou repositionnons des entreprises existies. Nous développons une identité complète, un ton de voix et une stratégie de positionnement qui différencie sur le marché.',
    trafegoPago: 'Trafic Payant',
    trafegoPagoDesc: 'Campagnes Meta Ads et Google Ads optimisées pour la conversion. Nous investissons votre budget intelligemment pour générer des leads qualifiés et des ventes réelles, pas seulement des clics.',
    estrategiaDigital: 'Stratégie Digitale',
    estrategiaDigitalDesc: 'Planification complète du marketing digital alignée sur vos objectifs commerciaux. Nous analysons le marché, définissons des objectifs clairs et créons le chemin vers une croissance durable.'
  },
  portfolio: {
    titulo: 'Portfolio',
    subtitulo: 'Quelques-uns de nos travaux récents',
    restaurante: 'Restaurant',
    hamburgueria: 'Burger',
    steakhouse: 'Steakhouse',
    sushi: 'Sushi',
    spa: 'Spa & Wellness',
    pastelaria: 'Pâtisserie',
    wine: 'Wine Bar',
    architecture: 'Architecture',
    catFotografia: 'Photographie & Branding',
    catProducao: 'Production Audiovisuelle',
    catGestao: 'Gestion des Réseaux Sociaux',
    catBranding: 'Branding Complet',
    catEstrategia: 'Stratégie Digitale',
    catConteudo: 'Contenu Visuel'
  },
  processo: {
    titulo: 'Comment nous travaillons',
    subtitulo: 'Un processus structuré et transparent qui garantit des résultats prévisibles et une croissance constante.',
    diagnostico: 'Diagnostic',
    diagnosticoDesc: 'Nous analysons votre entreprise, le marché et la concurrence pour identifier les opportunités de croissance et les points de différenciation.',
    estrategia: 'Stratégie',
    estrategiaDesc: 'Nous développons un plan personnalisé avec des objectifs clairs, un public cible défini et des tactiques spécifiques pour atteindre les résultats.',
    producao: 'Production',
    producaoDesc: 'Nous créons du contenu visuel à fort impact, des matériaux graphiques professionnels et des campagnes qui captent l\'attention et génèrent le désir.',
    publicacao: 'Publication',
    publicacaoDesc: 'Nous mettons en œuvre la stratégie de manière cohérente, gérant toutes les plateformes et optimisant chaque publication pour une portée maximale.',
    crescimento: 'Croissance',
    crescimentoDesc: 'Nous surveillons les résultats, ajustons les tactiques et développons ce qui fonctionne pour assurer une croissance continue et durable.'
  },
  depoimentos: {
    titulo: 'Ce que disent nos clients',
    subtitulo: 'Résultats réels de marques qui ont fait confiance à notre stratégie et ont grandi de manière durable.',
    depoimento1: 'Olhar Criativo a complètement transformé notre présence digitale. En 6 mois, nous avons triplé le nombre de réservations provenant des réseaux sociaux. Leur travail est impeccable.',
    depoimento2: 'Professionnalisme du début à la fin. L\'équipe a parfaitement compris notre vision et a créé une identité visuelle qui nous distingue sur le marché. Je recommande sans hésiter.',
    depoimento3: 'Nous avons enfin trouvé une agence qui livre des résultats réels. Le ROI des campagnes de trafic payant a dépassé toutes les attentes. Un partenariat à poursuivre.',
    proprietario: 'Propriétaire',
    diretora: 'Directrice Marketing',
    ceo: 'PDG'
  },
  formulario: {
    titulo: 'Prêt à grandir?',
    subtitulo: 'Remplissez le formulaire et recevez une proposition personnalisée pour transformer la présence digitale de votre entreprise.',
    nome: 'Nom Complet',
    nomePlaceholder: 'Votre nom',
    empresa: 'Entreprise',
    empresaPlaceholder: 'Nom de l\'entreprise',
    area: 'Secteur d\'Activité',
    areaPlaceholder: 'Sélectionnez une option',
    restauracao: 'Restauration',
    hotelaria: 'Hôtellerie',
    moda: 'Mode',
    beleza: 'Beauté & Bien-être',
    comercio: 'Commerce Local',
    servicosPro: 'Services Professionnels',
    outro: 'Autre',
    objetivo: 'Objectif Principal',
    objetivoPlaceholder: 'Décrivez ce que vous souhaitez atteindre (max. 500 caractères)',
    orcamento: 'Budget Approximatif',
    telefone: 'Téléphone',
    telefonePlaceholder: '+351 910 000 000',
    enviar: 'Envoyer la Demande de Devis',
    enviando: 'Envoi en cours...',
    sucesso: '✓ Demande envoyée avec succès! Nous vous contacterons bientôt.',
    erro: '✗ Erreur lors de l\'envoi. Veuillez réessayer.',
    caracteres: 'caractères'
  },
  footer: {
    descricao: 'Agence de marketing digital et de production créative spécialisée dans la transformation des marques en références du marché grâce à la stratégie, au design et au contenu professionnel.',
    servicos: 'Services',
    contacto: 'Contact',
    direitos: 'Tous droits réservés.'
  }
};
